export default {
  siteId: "3",
  siteName: "fr",
  site: "fr",
  lang: "French",
  langCode: "fr-FR",
  activityName: "leave_a_review",
  productList: "Liste de produits",
  POST: "PUBLIER",
  Score: "Note",
  Title: "Titre",
  Review: "Avis",
  Media: "Média",
  MediaType:
    "Les types de fichiers pris en charge incluent JPEG, JPG, PNG ou MP4.",
  MediaReward:
    "Partagez des photos ou des vidéos pour débloquer des récompenses spéciales.",
  RewardQa:
    "Répondez à toutes les questions ci-dessous pour des récompenses supplémentaires.",
  MoreQa: "Cliquez pour remplir plus de questions.",
  RewardsToast: "Votre récompense a été créditée avec succès sur votre compte.",
  rateLevel1: "Très insatisfait",
  rateLevel2: "Plutôt insatisfait",
  rateLevel3: "Ni satisfait, ni insatisfait",
  rateLevel4: "Plutôt satisfait",
  rateLevel5: "Très satisfait",
  "LEAVE A REVIEW": "Veuillez laisser un avis",
  "Please enter a star rating for this review":
    "Veuillez entrer une évaluation par étoiles pour cet avis",
  "Review’s title can’t be empty":
    "Le titre et le contenu de l'avis sont requis",
  "Review’s body can’t be empty":
    "Le titre et le contenu de l'avis sont requis",
  "Please upload a media less than 10 megabytes":
    "Veuillez télécharger un média de moins de 10 mégaoctets",
  "Please upload a media less than 20 megabytes":
    "Veuillez télécharger un média de moins de 20 mégaoctets",
  "THANK YOU FOR YOUR COMMENTS": "MERCI POUR VOS COMMENTAIRES",
  "We love seeing reviews":
    "Nous vous remercions d'avoir pris le temps de nous fournir des commentaires détaillés et constructifs.",
  "fill out":
    "Veuillez remplir le formulaire ci-dessous et publier votre avis sur le site, nous l'apprécierons.",
  "SUBMIT YOUR REVIEW": "PUBLIER VOTRE AVIS",
  shopping:
    "https://fr.cupshe.com/collections/maillots-de-bain-cupshe?utm_source=automatic&utm_medium=email&utm_campaign=review_shopping",
  mailto: "customercare",
  pageTitle: "Avis clients",
  "VIEW COMMENTS": "VOIR LES AVIS",
  "GO SHOPPING": "FAIRE DES ACHATS",
  mailText: `Pour vous assurer de recevoir nos mises à jour par e-mail, veuillez ajouter <a style="color:#333;text-decoration: underline;" class="c-muli-light" href="mailto:{mailto}{domain}">{mailto}{domain}</a> à votre carnet d'adresses.`,
  email: "E-Mail",
  "contact us": "Contactez-nous",
  contactUrl:
    "https://fr.cupshe.com/pages/contactez-nous?utm_source=automatic&utm_medium=email&utm_campaign=review_contact",
  next: "Suivant",
  copyright: "Copyright © {year} Cupshe {sitename}, Tous droits réservés.",
  subscribe1:
    "Vous avez bien été désabonné(e) des messages marketing de Cupshe FR.",
  subscribe2: "Vous n’aviez pas l’intention de vous désabonner ?",
  subscribe3: "RÉABONNEZ-VOUS",
  subscribe4:
    "Vous avez été réabonné avec succès aux messages marketing de Cupshe FRANCE.",
  "You're already on the list!": "Vous êtes déjà sur la liste !",
  "Oops, there was a hiccup!Please try again.":
    "Il y a eu un problème ! Veuillez réessayer.",
  unsubscribe: "se désabonner",
  continuesubscribe: "CONTINUER À S'ABONNER",
  trustsubscribe:
    "Merci de votre confiance, nous vous fournirons de meilleurs services et des produits plus abordables.",
  mailContact:
    'Veuillez contacter le <a href="https://fr.cupshe.com/pages/contact-us" class="contact_link">service clientèle</a> pour obtenir de l\'aide',
  policyText:
    "Veuillez noter qu'après votre désabonnement, vous pourriez recevoir des emails contenant des informations contractuelles concernant vos futurs achats en ligne. Par exemple, confirmation de commande, notification d'expédition, notification de remboursement, etc.",
};
